import React from 'react';
import IconV1, { IconV1Props } from 'ReactApp/Components/IconV1/IconV1';

type LinkWithIconV1Props = {
    href?: string,
    label?: string,
    classes?: string[],
    attrs?: {},
    iconProps?: IconV1Props,
    onClick?: React.MouseEventHandler,
}

const LinkWithIconV1 = (props: LinkWithIconV1Props) => {
    
    let classes = ['link-with-icon-v1'];
    if (Array.isArray(props.classes)) {
        classes.push(...props.classes);
    }

    return (
        <a 
            onClick={props.onClick}
            className={classes.join(' ')}
            href={props.href as string}
            {...props.attrs}
            >
            {props.iconProps !== undefined && (
                <IconV1 {...props.iconProps} />
            )}
            {props.label !== undefined && props.label}
        </a>
    );

}

export default LinkWithIconV1;